import { Map } from "immutable";

import { State, did_any_change, get_state } from "../../redux/State";
import { Keys } from "../../redux/Datastore";
import { Workorder } from "../../workorders/Workorder";
import { WorkordersCollection } from "../../workorders/WorkordersCollection";
import { Id_floor } from "../../api/Identifiers";
import { Dispatcher, dispatch_action } from "../../redux/Dispatcher";
import { Action, Actions } from "../../redux/Actions";
import { Cookie } from "../../Cookies";
import { CssElement } from "../../css_utils";
import { Configuration } from "../../Configuration";

class WorkorderMenuItem {
    private _count: number = 0;
    public readonly icon: string = "UNINITIAIZED";
    private _icon_red: string = "UNINITIAIZED";
    private _icon_yellow: string = "UNINITIAIZED";
    public readonly label: string = "UNINITIAIZED";
    public readonly type: string = "UNINITIAIZED";
    private _contains_red: boolean = false;
    private _contains_yellow: boolean = false;
    public constructor(workorder: Workorder) {
        // use abbreviations to save space in the menu
        this.label = workorder.category.replace("Maintenance", "Maint.");
        if (!workorder.active) {
            this.label += " - Closed";
        }
        this._count = 0;
        this.icon = workorder.icon_plain;
        this._icon_red = workorder.icon_red;
        this._icon_yellow = workorder.icon_yellow;
        this._contains_red = workorder.is_red;
        this._contains_yellow = workorder.is_yellow;
        this.type = workorder.type;
    }
    public get count(): number { return this._count; }
    public get id(): string {
        let menu_item_id: string = `id__${this.type}`;
        menu_item_id = menu_item_id.replace(/[^0-9a-zA-Z]/g, "_");
        return menu_item_id;
    }
    public increment(): void {
        this._count++;
    }
    public update(workorder: Workorder) {
        if (workorder.is_red) {
            this._contains_red = true;
        }
        if (workorder.is_yellow) {
            this._contains_yellow = true;
        }

    }
    public toJSON(): any {
        let r: any = {
            count: this._count,
            icon: this.icon,
            label: this.label,
            type: this.type,
        };
        if (this._contains_red) {
            r.icon = this._icon_red;
        }
        else if (this._contains_yellow) {
            r.icon = this._icon_yellow;
        }
        return r;
    }
}


export class WorkordersMenu {

    public get categories(): string[] {
        return Object.keys(this._workorder_menu_items);
    }

    private _workorder_menu_items: { [key: string]: WorkorderMenuItem } = {};
    public get workorder_menu_items(): { [key: string]: WorkorderMenuItem } {
        return this._workorder_menu_items;
    }

    public toJSON(): any {
        let a: string = JSON.stringify(this._workorder_menu_items);
        let r: any = JSON.parse(a);
        return r;

    }
    public add(workorder: Workorder) {
        if (!(workorder.type in this._workorder_menu_items)) {
            this._workorder_menu_items[workorder.type] = new WorkorderMenuItem(workorder);
        }
        this._workorder_menu_items[workorder.type].increment();
        this._workorder_menu_items[workorder.type].update(workorder);
    }

    // assume the workorders being passed in are already filtered for the correct floor
    public constructor(workorders: WorkordersCollection) {
        workorders.workorders.forEach((workorder: Workorder) => {
            this.add(workorder);
        });
    }
}


export class UI {

    public static append_menu_row(li: HTMLLIElement): void {
        if (li) {
            UI.menu_workorders_content_list_ul.appendChild(li);
        }
    }

    public static append_menu_row_html(html: string): void {
        return this.append_menu_row(UI.li_from_html(html));
    }

    public static li_from_html(html: string): HTMLLIElement {
        return <HTMLLIElement>$.parseHTML(html.trim())[0];
    }


    public static get menu_row_count(): number {
        return $("#menu_workorders_container ul li").length;
    }

    public static get menu_workorders_container_div(): HTMLDivElement {

        return <HTMLDivElement>document.getElementById("menu_workorders_container");
    }
    public static get menu_workorders_header(): HTMLElement {

        return document.getElementById("menu_workorders_header");
    }


    public static get menu_workorders_content_list_ul(): HTMLUListElement {
        return <HTMLUListElement>document.getElementById("menu_workorders_content_list");
    }
    public static get menu_workorders_content(): HTMLElement {
        return <HTMLElement>document.getElementById("menu_workorders_content");
    }
    public static get menu_workorders_content_css(): CssElement {
        return new CssElement(UI.menu_workorders_content);
    }

    public static set expanded(is_expanded: boolean) {
        if (is_expanded) {
            $("#menu_workorders_header_chevron").attr("class", "glyphicon glyphicon-chevron-down");
            UI.menu_workorders_content_css.visibility = true;
        } else {
            $("#menu_workorders_header_chevron").attr("class", "glyphicon glyphicon-chevron-right");
            UI.menu_workorders_content_css.visibility = false;
        }
    }
    public static get expanded(): boolean {
        return UI.menu_workorders_content_css.visibility;
    }
}


/**
 * 
 * @param state 
 */
export function update_menu_workorders_content(imm_state: Map<any, any>): Map<any, any> {
    return __update_menu_workorders_content(State.wrap(imm_state)).toImmutable();
}

function __update_menu_workorders_content(old_state: State): State {

    let id_floor: Id_floor = old_state.id_floor;
    let data_workorders: WorkordersCollection = old_state.workorders;
    const assetsFiltered = old_state.assetsFiltered;

    let menu_workorders_content: WorkordersMenu = new WorkordersMenu(data_workorders.get_for_floor(id_floor).get_by_assets(assetsFiltered, old_state.is_asset_filter_active));
    return old_state.set_obj(Keys.MENU_WORKORDERS_CONTENT, menu_workorders_content.toJSON());
}


function on_workorders_menu_header_click(this: HTMLElement, ev: MouseEvent) {
    let csse: CssElement = new CssElement(UI.menu_workorders_content); // !(.style.visibility === "visible");
    let expanding: boolean = !(new CssElement(UI.menu_workorders_content).visibility); // !(.style.visibility === "visible");
    Cookie.write_bool(Keys.MENU_WORKORDERS_EXPANDED, expanding);
    Dispatcher.dispatch_action(Action.set_key_boolean(Keys.MENU_WORKORDERS_EXPANDED, expanding));

}




function force_draw_workorders_menu(): void {

    let state: State = get_state();
    UI.menu_workorders_content_list_ul.innerHTML = "";  // clear out all workorders
    let rows: number = UI.menu_row_count;


    //            let content = state.menu_workorders_content;//.me.get_obj(Keys.MENU_WORKORDERS_CONTENT, {});//.menu_workorders_content
    let id_floor: Id_floor = state.id_floor;
    let data_workorders: WorkordersCollection = state.workorders;
    const assetsFiltered = state.assetsFiltered;
    let menu_workorders_content: WorkordersMenu = new WorkordersMenu(data_workorders.get_for_floor(id_floor).get_by_assets(assetsFiltered, state.is_asset_filter_active));

    Object.keys(menu_workorders_content.workorder_menu_items).forEach((key: string) => {
        let item: WorkorderMenuItem = menu_workorders_content.workorder_menu_items[key];
        let badge: string = "";
        if (item.count > 0) {
            badge = item.count.toString();
        }
        let html = `<li style='padding: 2px' class='list-group-item'>
                    <img src='${item.icon}'  width='20' height='20' />
                    <span style='display: inline-block; width:165px;'>
                    <a href='#' id='${item.id}' >
                    ${item.label}
                    </a>
                    </span>
                    <span class='badge'>${badge}</span>
                    </li>`;
        UI.append_menu_row_html(html);
        let anchor = $("#" + item.id);
        let li = anchor.parent("li");

        anchor.data("workorder_type", item.type);
        li.data("workorder_type", item.type);
        let isSelected: boolean = _.includes(state.menu_workorders_selected, item.type);
        if (isSelected) {
            li.addClass("selected");
        }

        anchor.click(function (menuItemAnchor_click) {
            anchor = $(menuItemAnchor_click.currentTarget);
            let workorder_type = anchor.data("workorder_type");
            let wasSelected = _.includes(get_state().menu_workorders_selected, workorder_type);
            isSelected = !wasSelected;
            Dispatcher.dispatch_action(Action.set_workorder_category_selected(workorder_type, isSelected));
        });

    });

    // add select all, clear all, and create items
    // TODO: split the <a> tag such that the glyphicon can be styled to stay black on hover. the text link should
    // underline and look like a clickable link.
    // let li:HTMLLIElement =  <HTMLLIElement>document.createElement("li")
    // li.classList.add('list-group-item');
    // li.style.setProperty("padding", "2px");

    if (UI.menu_row_count > 0) {
        if (menu_workorders_content.categories.length > 0) {

            let html: string = `<li class=" list-group-item" style="padding: 2px">
        
        <a href="#" id="workorders_menu_selectall">
        <span class= "glyphicon glyphicon-check"></span>&nbsp;
        Select All
        </a>
        </li>`;
            UI.append_menu_row_html(html);

            html = "<li class=\" list-group-item\" style=\"padding: 2px\"><a href=\"#\" id=\"workorders_menu_clear\"    ><span class= \"glyphicon glyphicon-unchecked\"></span>&nbsp;Clear All</a></li>";
            UI.append_menu_row_html(html);

            document.getElementById("workorders_menu_clear").onclick = onclick_clear;
            document.getElementById("workorders_menu_selectall").onclick = onclick_select_all;
        }
    }
    if (!Configuration.read_only_mode) {
        let html: string = "<li class=\" list-group-item\" style=\"padding: 2px\"><a href=\"#\" id=\"workorders_menu_new\" ><span class= \"glyphicon glyphicon glyphicon-plus\"></span>&nbsp;Create a new work order</a></li>";
        UI.append_menu_row_html(html);
        document.getElementById("workorders_menu_new").onclick = onclick_create_new;
    }
    if (UI.menu_row_count == 0) {
        new CssElement(UI.menu_workorders_container_div).hide();
    } else {
        new CssElement(UI.menu_workorders_container_div).show();
    }
    
}


export function draw_workorders_menu(): void {
    if (!Configuration.workorders_feature_enabled) {
        return;
    }
    if (did_any_change([Keys.KEY_STATE_FIRST_RUN])) {
        // set click handler
        UI.menu_workorders_header.onclick = on_workorders_menu_header_click;
    }

    let state: State = get_state();

    if (did_any_change([Keys.MENU_WORKORDERS_EXPANDED, Keys.KEY_STATE_FIRST_RUN])) {
        UI.expanded = state.menu_workorders_expanded;
    }

    //    if (did_any_change([Keys.ID_FLOOR, Keys.MENU_WORKORDERS_SELECTED, Keys.DATA_WORKORDERS])) {
    let contentDiv = $("#menu_workorders_content");

    let content_hash = contentDiv.data("content_hash");

    // if the floor changed, redraw the menu

    let redraw_menu: boolean = did_any_change([Keys.MENU_WORKORDERS_SELECTED, Keys.MENU_WORKORDERS_CONTENT, Keys.ID_FLOOR, Keys.KEY_STATE_FIRST_RUN, Keys.DATA_ASSETS_JSON, Keys.DATA_WORKORDERS]);

    if (redraw_menu) {
        force_draw_workorders_menu();
    }

    // update the selections on every repaint
    // AWH TODO: for some reason setting selected here is not working.
    // needs investigation ...
    $("#menu_workorders_content_list li").each(function (idx, li) {
        let a = $(li).find("a");
        let workorder_type = a.data("workorder_type");
        if (_.includes(state.menu_workorders_selected, workorder_type)) {
            $(li).addClass("selected");
        }
        else {
            $(li).removeClass("selected");
        }
    });
}


function onclick_clear() {
    dispatch_action(Action.toggle_all_workorder_categories(false));
}

function onclick_select_all() {
    dispatch_action(Action.toggle_all_workorder_categories(true));
}

function onclick_create_new() {
    Dispatcher.dispatch(Actions.SET_ADD_WORKORDER_STATE, true);
}